<template>
  <Dialog
    top=""
    custom-class="pg-dialog pg-dialog-table-package"
    :title="title"
    :visible="showDrawer"
    :modal="modal"
    :before-close="onCancel"
    :append-to-body="appendToBody"
    :width="width"
    @close="close"
    @closed="closed"
    @opened="init"
  >
    <PgTable
      class="pg-dialog-table-package-table"
      ref="tableRef"
      height="auto"
      :columnTableCode="columnTableCode"
      :isSelection="!disabled"
      :extendCompileData="extendCompileData"
      :buttonTop="buttonTop"
      :buttonRow="buttonRow"
      :customAction="customAction"
      :rowShortcutNum="1"
      :rowConfig="rowConfig"
      :seachKeys="seachKeys"
      :seachPlaceholder="seachPlaceholder"
      :defaultSearchIcon="defaultSearchIcon"
      rowButtonOnlyIcon
      @checkbox-change="checkboxChange"
      @checkbox-all="checkboxChange"
      @column-change="columnChange"
    >
    </PgTable>
    <template #footer>
      <slot name="footer">
        <ElButton style="min-width: 120px" round @click="handleCancel" v-if="props.cacelText">{{
          props.cacelText
        }}</ElButton>

        <ElButton
          v-if="sureText"
          style="min-width: 120px"
          type="primary"
          round
          @click="submit"
          :loading="sureLoading"
        >
          {{ sureText }}
        </ElButton>
      </slot>
    </template>
  </Dialog>
</template>
<script setup>
// 弹窗操作套包、定数包、定数盒、一物一码
import { PgTable } from '../../table/index'
import { Dialog } from 'element-ui'
import { toRef, ref, shallowRef, reactive } from 'vue'
import { useDrawerPack } from '../../../hooks/index'

const props = defineProps({
  appendToBody: {
    type: Boolean,
    default: true,
  },
  visible: {
    type: Boolean,
    default: true,
  },
  modal: {
    type: Boolean,
    default: true,
  },
  title: {
    type: String,
    default: '选择',
  },
  width: {
    type: String,
    default: '1200px',
  },
  columnTableCode: String,
  url: [String, Array, Function],
  value: [String, Array, Object, Number],
  cacelText: {
    type: String,
    default: '取消',
  },
  sureText: {
    type: String,
    default: '确认',
  },
  onOk: Function,
  disabled: {
    type: Boolean,
    default: true,
  },
  rowConfig: Object,
  seachKeys: Array,
  seachPlaceholder: String,
  defaultSearchIcon: String,
})
const emit = defineEmits(['update:visible', 'close', 'closed', 'on-cancel', 'on-ok'])
const { showDrawer, close, closed, onCancel, closeDrawer, handleCancel } = useDrawerPack(
  toRef(props, 'visible'),
  emit
)

const tableRef = ref(null)
const tableData = shallowRef([])
const isColumn = ref(false)
const columnChange = () => {
  isColumn.value = true
  if (tableData.value?.length > 0) {
    tableRef.value.loadData(tableData.value)
  }
}
const init = async () => {
  tableData.value = Array.isArray(props.url) ? props.url : []
  selections.value = []
  if (isColumn.value) {
    tableRef.value.loadData(tableData.value)
  }
}

const selections = shallowRef([])
const extendCompileData = reactive({
  selections,
})
const checkboxChange = () => {
  selections.value = props.url.filter((item) => item.checked)
}
const buttonTop = props.disabled
  ? []
  : [
      {
        id: 'delates',
        style: 'error',
        icon: 'ivu-icon-icon-pg-delete',
        name: '删除',
        leaf: true,
        children: [],
        enableExp: '{{selections.length > 0}}',
      },
    ]
const buttonRow = props.disabled
  ? []
  : [
      {
        id: 'delate',
        style: 'error',
        icon: 'ivu-icon-icon-pg-delete',
        name: '删除',
        leaf: true,
        children: [],
      },
    ]
const customAction = (menu, compileSource) => {
  if (menu.id === 'delates') {
    tableData.value = tableData.value.filter(
      (item) => !selections.value.some((im) => item.goodsStore?.epc === im.goodsStore?.epc)
    )
    selections.value = []
    tableRef.value.loadData(tableData.value)
  } else if (menu.id === 'delate') {
    tableData.value = tableData.value.filter(
      (item) => item.goodsStore?.epc !== compileSource.row.goodsStore?.epc
    )
    selections.value = [...selections.value.filter((item) => item._ID !== compileSource.row._ID)]
    tableRef.value.loadData(tableData.value)
  }
}

const sureLoading = ref(false)
const submit = async () => {
  if (props.onOk) {
    await props.onOk(tableData.value)
  }
  closeDrawer()
}
</script>
<style lang="scss">
@import '../style/dialog-table-package.scss';
</style>
